import axios from "axios";
import Crypto from "./crypto.js";
import { CryptoKey } from "./emunData";
axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    if (
      error &&
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      errorCb.forEach((cb) => {
        cb(error.response.status);
      });
    }

    // Do something with response error
    return Promise.reject(error);
  }
);

const errorCb = [];
const addHttpErrorListener = (cb) => {
  if (typeof cb === "function") {
    errorCb.push(cb);
  }
};

const removeHttpErrorListener = (cb) => {
  const index = errorCb.indexOf(cb);
  if (index > -1) {
    errorCb.splice(index, 1);
  }
};

/**
 * Send http get request
 */
const httpGet = (apiUrl, config) => {
  if (!config) config = getAuthHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl, config)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

/**
 * Send http post request
 */
const httpPost = (apiUrl, data, config) => {
  if (!config) config = getAuthHeaders();

  return new Promise((resolve, reject) => {
    axios
      .post(apiUrl, data, config)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

/**
 * Send http put request
 */
const httpPut = (apiUrl, data, config) => {
  if (!config) config = getAuthHeaders();

  return new Promise((resolve, reject) => {
    axios
      .put(apiUrl, data, config)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

/**
 * Send http delete request
 */
const httpDelete = (apiUrl, data, config) => {
  if (!config) config = getAuthHeaders();
  config.data = data;

  return new Promise((resolve, reject) => {
    axios
      .delete(apiUrl, config)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

const httpUploadFormData = (apiUrl, formData, config) => {
  if (!config) config = getAuthHeaders();

  return new Promise((resolve, reject) => {
    axios
      .post(apiUrl, formData, config)
      .then(function (response) {
        return resolve(response.data);
      })
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

const httpDownloadData = (apiUrl, formData, config) => {
  if (!config) config = getAuthHeaders();
  config.responseType = "blob";

  return new Promise((resolve, reject) => {
    axios
      .post(apiUrl, formData, config)
      .then(function (response) {
        return resolve(response);
      })
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

/**
 * Send http get request without auth
 */
const httpNoAuthGet = (apiUrl) => {
  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((error) => {
        return reject(error.response ? error.response.data : error);
      });
  });
};

/**
 * Send http post request without auth
 */
const httpNoAuthPost = (apiUrl, data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(apiUrl, data)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((error) => {
        return reject(error.response ? error.response.data : error);
      });
  });
};

/**
 * Auth header
 */
const getAuthHeaders = () => {
  if (
    localStorage.getItem("LAST_USERNAME") &&
    localStorage.getItem("LAST_PASSWORD")
  ) {
    //downward compatibility old authenticate method
    let username = Crypto.decrypt(
      localStorage.getItem("LAST_USERNAME"),
      CryptoKey
    );
    let password = Crypto.decrypt(
      localStorage.getItem("LAST_PASSWORD"),
      CryptoKey
    );
    return {
      headers: { Authorization: "Basic " + btoa(username + ":" + password) },
    };
  } else if (localStorage.getItem("JWT")) {
    //use latest authenticate method
    return {
      headers: { Authorization: "Bearer " + localStorage.getItem("JWT") },
    };
  } else {
    return {};
  }
};

export {
  removeHttpErrorListener,
  addHttpErrorListener,
  getAuthHeaders,
  httpNoAuthGet,
  httpNoAuthPost,
  httpGet,
  httpPost,
  httpPut,
  httpDelete,
  httpUploadFormData,
  httpDownloadData,
};
